angular.module 'zc.projects'

.directive 'zcLoginEvaluatorsList', (ProjectLoginEvaluator) ->
  restrict: "E"
  scope:
    project: "="
  templateUrl: "/templates/projects/directives/projects/login_evaluators_list.html"

  link: (scope, element, attrs) ->
    scope.login_evaluators = []
    ProjectLoginEvaluator.all scope.project.id
    .then (res) ->
      scope.login_evaluators = res




// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects/directives/projects/login_evaluators_list.directive.coffee